// provided for additional debuggability
export const DEBUG_CLIENT_ORIGINATED = Symbol('record-originated-on-client');
export const DEBUG_IDENTIFIER_BUCKET = Symbol('identifier-bucket');